import React, { memo, forwardRef } from "react";
const SvgSystemicdifference = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M15.128 11.856L9.003 22.882h12.062l-5.937-11.026zm-.398-3.4a1 1 0 011.748 0l8.3 14.94a1 1 0 01-.874 1.486h-16.6a1 1 0 01-.875-1.486l8.3-14.94z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgSystemicdifference.displayName = "SvgSystemicdifference";
const MemoForwardRef = memo(SvgSystemicdifference);
export default MemoForwardRef;
